<template>
  <InputGroup class="input-number" :class="inputGroupClass">
    <InputNumber
      v-model="input"
      v-bind="attrs"
      :input-id="id"
      :currency="effectiveCurrrencyForFormatting"
      :disabled="disabled"
      :locale="locale"
      :allow-empty="false"
      use-grouping
    />

    <InputGroupAddon
      v-if="effectiveCurrrencyForFormatting !== Currency.USD"
      class="input-number-inputgroup"
    >
      {{ effectiveCurrrencyForFormatting }}
    </InputGroupAddon>
  </InputGroup>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs, useAttrs } from 'vue';

import { Currency } from '@rygen/rygen-ui/model';

import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import InputNumber from 'primevue/inputnumber';

defineOptions({ inheritAttrs: false });

const input = defineModel({
  type: Number,
  default: () => 0,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  currency: {
    type: String as PropType<Currency>,
    default: () => Currency.USD,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  inputGroupClass: {
    type: String,
    default: () => '',
  },
});
const { id, currency, disabled, inputGroupClass } = toRefs(props);

const attrs = useAttrs();

const effectiveCurrrencyForFormatting = computed((): string => {
  return currency.value ?? Currency.USD;
});

const locale = computed((): string => {
  switch (effectiveCurrrencyForFormatting.value) {
    case Currency.USD:
      return 'en-US';
    case Currency.CAD:
      return 'en-CA';
    case Currency.MXN:
      return 'es-MX';
    default:
      return navigator.language;
  }
});
</script>

<style>
.input-number.p-inputgroup {
  .p-inputnumber {
    width: 100%;
  }
}

/* Only apply when nested in another InputGroup component */
.input-number.no-right-radius.p-inputgroup {
  .p-inputgroupaddon {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>
